<template>
  <v-select
    clearable
    dense
    :disabled="disabled"
    hide-details
    item-text="text"
    item-value="value"
    outlined
    required
    :data-testid="dataTestId"
    :items="hours"
    :label="label || $t('routines_reminder.set_time')"
    :menu-props="{ bottom: true, offsetY: true }"
    :placeholder="label || $t('routines_reminder.set_time')"
    :prepend-inner-icon="icon"
    :value="selectedHour"
    @change="changeHour"
  />
</template>
<script>
import moment from 'moment'

export default {
  name: 'HourSelector',

  data() {
    return {
      hours: [],
    }
  },

  mounted() {
    this.createHours()
  },

  props: {
    dataTestId: String,
    disabled: Boolean,
    icon: String,
    label: String,
    selectedHour: { type: String },
  },

  methods: {
    changeHour(value) {
      this.$emit('change', value)
    },

    createHours() {
      const startHour = moment('00:00', 'HH:mm')
      const endHour = moment('23:30', 'HH:mm')
      const interval = 30
      const hoursList = []

      for (
        let initialHour = moment(startHour);
        initialHour.isSameOrBefore(endHour);
        initialHour.add(interval, 'minutes')
      ) {
        hoursList.push({
          text: initialHour.format('hh:mm A').toLowerCase(),
          value: `${initialHour.hour()}:${initialHour.minute()}`,
        })
      }
      this.hours = hoursList
    },
  },
}
</script>
